import { get, groupBy, mapValues } from 'lodash';

import { UNIT_TYPES } from 'constants/unitTypes';
import { MAX_ALLOWED_SOIL_TYPES } from 'constants/values';
import { convert } from 'util/unitConversion';
import { calcAreaForZoneGeoJson } from 'util/zoneOperations';
import { collectPropertiesLegacy } from 'util/zoneProperties';

export const getLatestSoilDataForFieldId = (state, fieldId) => {
  let soilData = get(state, `imagery.${fieldId}.soil`);
  return soilData ? soilData[Object.keys(soilData).sort((a,b) => b-a)[0]] : {};
};

const collectSoilDisplayProperties = ({ soilsInZone, totalZoneArea }) => {
  return Object.values(soilsInZone).map((soilsArray) => {
    const sampleSoil = soilsArray[0];
    const totalSoilArea = soilsArray.reduce((total, soilProps) => {
      // matchingArea is in sq.meters
      const acres = convert({
        from: { q: (soilProps.matchingArea / 10000), u: UNIT_TYPES.hectare },
        to: { u: UNIT_TYPES.acre }
      });
      return total + acres.q;
    }, 0);
    const soilPercentageOfZone = Math.round((totalSoilArea / totalZoneArea.q) * 100);
    return {...sampleSoil, percentage: { q: soilPercentageOfZone, u: UNIT_TYPES.percent }};
  });
};

export const getSoilCompositionForZones = ({ fieldId, state, zones }) => {
  return mapValues(zones, (zone) => {
    const { meta, geoJson } = zone;

    const soilData = getLatestSoilDataForFieldId(state, fieldId);
    const soilIntersection = collectPropertiesLegacy( // TODO - revise code to use a different function.
      { features: Object.values(soilData).map((zoneA) => zoneA.geoJson) },
      geoJson,
      { useLibraries: ['MFOGEL'] }
    );
    const soilsInZone = groupBy(soilIntersection, 'parsed-muname');
    const totalZoneArea = meta.area || calcAreaForZoneGeoJson(geoJson);
    let displaySoils = collectSoilDisplayProperties({ soilsInZone, totalZoneArea });
    displaySoils = displaySoils.sort((a, b) => b.percentage.q - a.percentage.q).slice(0, MAX_ALLOWED_SOIL_TYPES);

    const displayArea = displaySoils.reduce((total, soil) => total + soil.percentage.q, 0);
    if (displayArea < 100) {
      displaySoils.push({ percentage: { q: (100 - displayArea), u: UNIT_TYPES.percent } });
    }
    return displaySoils;
  });
};
